/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';

import {LAYOUT} from '@/constants/appStyle';
import {useWifiListContext} from '@/contexts/WifiListContext';
import {useWifiSettingContext} from '@/contexts/WifiSettingContext';

import WifiAddNetwork from './WifiAddNetwork';
import WifiItem from './WifiItem';

function WifiList() {
  const {wifiList} = useWifiListContext();
  const {selectedWifi} = useWifiSettingContext();

  const WifiListStyle = css({
    /**
     * 30px comes from =>
     *  10px of line border on top menu and bottom menu
     *  20px for margin top and bottom
     */
    height: `calc(${LAYOUT.heightResolution} - (${LAYOUT.bottomMenuHeight} + ${LAYOUT.topMenuHeight}) - 30px)`,
    width: '100%',
    margin: '10px 0',
    marginLeft: '10px',
    padding: '0px 15px',
    overflowY: 'auto',
  });

  const availableWifi = wifiList.map((wifi) => (
    <WifiItem
      key={wifi.Name}
      wifi={wifi}
      isSelected={selectedWifi && selectedWifi.Name === wifi.Name}
    />
  ));

  const addNetwork = (
    <WifiAddNetwork
      key="Add Network"
      wifi={{
        IsConnected: false,
        MacAddress: null,
        Name: 'Add Network',
        Password: null,
        Strength: 'Low',
      }}
      isSelected={selectedWifi === 'Add Network'}
    />
  );

  return (
    <div css={WifiListStyle}>
      {addNetwork}
      {availableWifi}
    </div>
  );
}
export default WifiList;
